import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './components/App';

// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import { BrowserRouter as Router } from 'react-router-dom'
import { positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from "react-alert-template-basic";
import { Provider } from 'react-redux'
// REDUX REDUCER
import store from './redux/store'


ReactDOM.render(
  <Provider store={store}>
    <AlertProvider template={AlertTemplate} timeout={3000} position={positions.TOP_CENTER}>
      <Router basename="/v2/">
        <App />
      </Router>
    </AlertProvider>
  </Provider>
  , document.getElementById('root'));


// registerServiceWorker();
unregister();
